import { useEffect, useRef, useState } from "react";
import { notification } from "antd";
import { useDispatch } from "react-redux";
import { getJobShiftSwms } from "../../../../../actions/v2/JobShiftSwmsActions";
import { Strings } from "../../../../../dataProvider/localize";

export default function useJobShiftSwmsViewModel({ open, context }) {
  const dispatch = useDispatch();
  const controller = useRef();
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [swms, setSwms] = useState(null);

  useEffect(() => {
    if (!open) {
      setLoading(false);
      setLoaded(false);
      setSwms(null);
      return undefined;
    }

    if (!context || !context.jobId || !context.shiftId || !context.swmsId) {
      setLoaded(true);
      setSwms(null);
      return undefined;
    }

    controller.current = new AbortController();
    setLoading(true);
    setLoaded(false);
    setSwms(null);

    dispatch(getJobShiftSwms(context, { signal: controller.current.signal }))
      .then((response) => setSwms(response || null))
      .catch((error) => {
        if (error && error.name === "AbortError") return;
        notification.error({
          message: Strings.error_title,
          description: typeof error === "string" ? error : "There was an error while fetching the Shift SWMS.",
          className: "ant-error"
        });
      })
      .finally(() => {
        setLoading(false);
        setLoaded(true);
      });

    return () => {
      if (controller.current) controller.current.abort();
    };
  }, [dispatch, open, context && context.jobId, context && context.shiftId, context && context.swmsId]);

  return { loading, loaded, swms };
}
